import React, { useState } from "react";


import {
  FaPlane,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

const RESPONSIVE_CSS = `
  .aap-hero-inner {
    width: 92% !important;
    padding: 38px 0px !important;
  }
  .aap-hero-icon {
    width: 44px !important;
    height: 44px !important;
  }
  .aap-hero-title {
    font-size: clamp(22px, 5vw, 34px) !important;
  }
  .aap-hero-desc {
    font-size: clamp(13px, 2vw, 15px) !important;
    line-height: 1.8 !important;
  }
  .aap-accordion-wrap {
    width: 92% !important;
    padding: 28px 0px 50px !important;
  }
  .aap-accordion-header {
    padding: 14px 16px !important;
    gap: 10px !important;
  }
  .aap-accordion-title {
    font-size: 15px !important;
  }
  .aap-accordion-content {
    padding: 16px 18px !important;
  }
  .aap-point-text {
    font-size: 14px !important;
  }

  @media (max-width: 600px) {
    .aap-hero-inner {
      width: 90% !important;
      padding: 28px 0px !important;
    }
    .aap-hero-row {
      gap: 10px !important;
      margin-bottom: 12px !important;
    }
    .aap-hero-icon {
      width: 38px !important;
      height: 38px !important;
      border-radius: 8px !important;
    }
    .aap-hero-icon svg {
      font-size: 17px !important;
    }
    .aap-hero-title {
      font-size: clamp(19px, 6vw, 26px) !important;
    }
    .aap-hero-desc {
      font-size: 13px !important;
      line-height: 1.7 !important;
    }
    .aap-accordion-wrap {
      width: 92% !important;
      padding: 20px 0px 36px !important;
    }
    .aap-accordion-header {
      padding: 12px 14px !important;
    }
    .aap-accordion-title {
      font-size: 14px !important;
      line-height: 1.4 !important;
    }
    .aap-accordion-content {
      padding: 14px 14px !important;
    }
    .aap-point-row {
      gap: 10px !important;
      margin-bottom: 10px !important;
    }
    .aap-point-check {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
    }
    .aap-point-check svg {
      font-size: 9px !important;
    }
    .aap-point-text {
      font-size: 13px !important;
      line-height: 1.6 !important;
    }
  }

  @media (max-width: 360px) {
    .aap-hero-title {
      font-size: 18px !important;
    }
    .aap-accordion-title {
      font-size: 13px !important;
    }
  }
`;

function AerospaceAviationPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Flight Operations & Navigation",
      points: [
        "Autonomous Flight Planning Agent",
        "In-flight Route Optimization Agent",
        "Air Traffic Coordination Agent",
        "Pilot Assistance Agent",
        "Runway Scheduling Agent",
      ],
    },

    {
      title: "Maintenance, Repair & Safety",
      points: [
        "Predictive Maintenance Agent",
        "Fault Detection Agent",
        "Digital Twin Maintenance Agent",
        "Inspection Drone Coordination Agent",
        "Maintenance Scheduling Agent",
      ],
    },

    {
      title: "Airport & Ground Operations",
      points: [
        "Passenger Flow Monitoring Agent",
        "Luggage Tracking Agent",
        "Autonomous Baggage Handling Agent",
        "Gate Allocation Agent",
        "Ground Crew Dispatch Agent",
      ],
    },

    {
      title: "Aerospace R&D and Manufacturing",
      points: [
        "Aerodynamic Simulation Agent",
        "Flight Data Analysis Agent",
        "AI Material Design Agent",
        "CAD Design Assistant Agent",
        "Manufacturing Quality Control Agent",
      ],
    },

    {
      title: "Customer Experience & Services",
      points: [
        "Virtual Booking Assistant Agent",
        "In-Flight Personalization Agent",
        "Baggage Issue Resolution Agent",
        "Flight Status Notification Agent",
        "Customer Feedback Sentiment Agent",
      ],
    },
  ];

  return (
    <>
      <style>{RESPONSIVE_CSS}</style>

      <div
        style={{
          background: "#22c7b8",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        {/* HERO SECTION */}
        <div
          style={{
            background: "#173b8f",
            width: "100%",
          }}
        >
          <div
            className="aap-hero-inner"
            style={{
              width: "92%",
              maxWidth: "1300px",
              margin: "0 auto",
              padding: "38px 0px",
              boxSizing: "border-box",
            }}
          >
            <div
              className="aap-hero-row"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "16px",
                flexWrap: "wrap",
              }}
            >
              <div
                className="aap-hero-icon"
                style={{
                  width: "44px",
                  height: "44px",
                  background: "#22c7b8",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FaPlane
                  style={{
                    color: "#ffffff",
                    fontSize: "20px",
                  }}
                />
              </div>

              <h1
                className="aap-hero-title"
                style={{
                  color: "#ffffff",
                  fontSize: "34px",
                  fontWeight: "700",
                  margin: 0,
                  fontFamily: "Exo, sans-serif",
                  wordBreak: "break-word",
                }}
              >
                Aerospace & Aviation
              </h1>
            </div>

            <p
              className="aap-hero-desc"
              style={{
                color: "#f2f2f2",
                fontSize: "15px",
                lineHeight: "1.9",
                maxWidth: "1000px",
                margin: 0,
              }}
            >
              This sector includes air travel, satellite systems,
              defense aviation, and space exploration. AI agents assist
              in route optimization, predictive maintenance, crew
              scheduling, autonomous flight systems, and mission control.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div
          className="aap-accordion-wrap"
          style={{
            width: "78%",
            maxWidth: "1050px",
            margin: "0 auto",
            padding: "28px 0px 50px",
            boxSizing: "border-box",
          }}
        >
          {sections.map((section, index) => (
            <div
              key={index}
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                marginBottom: "10px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              {/* HEADER */}
              <div
                onClick={() => toggle(index)}
                className="aap-accordion-header"
                style={{
                  padding: "14px 18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  background:
                    openIndex === index
                      ? "#173b8f"
                      : "#ffffff",
                  transition: "0.3s",
                  gap: "12px",
                  boxSizing: "border-box",
                }}
              >
                <h2
                  className="aap-accordion-title"
                  style={{
                    margin: 0,
                    fontSize: "16px",
                    fontWeight: "700",
                    color:
                      openIndex === index
                        ? "#ffffff"
                        : "#173b8f",
                    fontFamily: "Exo, sans-serif",
                    wordBreak: "break-word",
                    minWidth: 0,
                  }}
                >
                  {section.title}
                </h2>

                {openIndex === index ? (
                  <FaChevronUp
                    style={{
                      color: "#ffffff",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <FaChevronDown
                    style={{
                      color: "#173b8f",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                )}
              </div>

              {/* CONTENT */}
              {openIndex === index && (
                <div
                  className="aap-accordion-content"
                  style={{
                    padding: "18px 24px",
                    background: "#ffffff",
                    boxSizing: "border-box",
                  }}
                >
                  {section.points.map((point, i) => (
                    <div
                      key={i}
                      className="aap-point-row"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        className="aap-point-check"
                        style={{
                          width: "24px",
                          height: "24px",
                          minWidth: "24px",
                          borderRadius: "50%",
                          background: "#22c7b8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaCheck
                          style={{
                            color: "#ffffff",
                            fontSize: "10px",
                          }}
                        />
                      </div>

                      <p
                        className="aap-point-text"
                        style={{
                          margin: 0,
                          color: "#4b5563",
                          fontSize: "15px",
                          lineHeight: "1.7",
                          fontWeight: "500",
                          wordBreak: "break-word",
                        }}
                      >
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default AerospaceAviationPage;
